/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Limit_3_ValueInputs */

const en_svc_rag_limit_3_value = /** @type {(inputs: Svc_Rag_Limit_3_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each source has an owner and a way to update it.`)
};

const lv_svc_rag_limit_3_value = /** @type {(inputs: Svc_Rag_Limit_3_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katram avotam ir atbildīgais un veids, kā to atjaunināt.`)
};

/**
* | output |
* | --- |
* | "Each source has an owner and a way to update it." |
*
* @param {Svc_Rag_Limit_3_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_limit_3_value = /** @type {((inputs?: Svc_Rag_Limit_3_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Limit_3_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_limit_3_value(inputs)
	return en_svc_rag_limit_3_value(inputs)
});